//bootstrap
import { Button, Spinner } from "react-bootstrap";
//redux
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { setStatusUpdatePwd, selectStatusUpdatePwd } from "../../../../redux/reducer/user/userSlice";

//----------------------------------------------------------

export default function UserSubmit2({ formik }: any) {
    //redux
    const dispatch = useAppDispatch();
    const statusUpdatePwd = useAppSelector(selectStatusUpdatePwd);

    //function
    const switchButtons = () => {
        switch (statusUpdatePwd) {
            case "init": {
                return (
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                    >
                        Update password
                    </Button>
                );
            }
            case "load": {
                return (
                    <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                        <span className="visually-hidden">Loading...</span>
                    </Button>
                );
            }
            case "success": {
                return (
                    <Button variant="success" size="lg" disabled={true}>
                        Password updated
                    </Button>
                );
            }
            case "unsuccess": {
                return (
                    <Button
                        variant="warning"
                        size="lg"
                        onClick={() => {
                            dispatch(setStatusUpdatePwd("init"));
                        }}
                    >
                        Update unable
                    </Button>
                );
            }
            case "failed": {
                return (
                    <Button
                        variant="danger"
                        size="lg"
                        onClick={() => {
                            dispatch(setStatusUpdatePwd("init"));
                        }}
                    >
                        Connecion unable
                    </Button>
                );
            }
            default: {
            }
        }
    };

    //view
    return <>{switchButtons()}</>;
}
